import { inject, Injectable } from '@angular/core'

import type { Observable } from 'rxjs'

import { PagedResponse } from '@app/components/generic/generic'
import { ArchivesService } from '@app/generated/api/archives/archives.service'
import type { ArchivesPartnersListParams, Partner } from '@app/generated/api/model'

@Injectable({
  providedIn: 'root',
})
export class PartnersApi {
  private readonly archivesService = inject(ArchivesService)

  list (params: any): Observable<PagedResponse<Partner>> {
    return this.archivesService.partners(params as ArchivesPartnersListParams) as any
  }
}
